<div class="success-main-container">

  <div class="card-container">

    <img src="./assets/img/logo/openpay.webp"
         srcset="./assets/img/logo/openpay@2x.webp 2x,
             ./assets/img/logo/openpay@3x.webp 3x"
         class="openpay-logo"
         alt="openpay logo"
    >

    <div class="success-container">
      <img src="./assets/img/success/success-check.png"
           srcset="./assets/img/success/success-check@2x.png 2x,
             ./assets/img/success/success-check@3x.png 3x"
           class="success-check"
           alt="openpay logo"
      >
    </div>

    <span class="success-title">
      {{successTitle}}
    </span>

    <div class="success-content">
      <p>{{successMessage}}</p>
      <span class="go-back-hyperlink" (click)="goToCallbackUrl()">
        {{successButtonCta}}
      </span>
    </div>

  </div>

</div>
